import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FaExclamationTriangle } from "react-icons/fa";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const CustomToast = ({ title, text, type }) => (
  <div className="flex flex-col text-black gap-1 rounded-sm">
    <div className="flex flex-row items-center gap-2">
      {type === "Info" && <AiOutlineInfoCircle className="text-yellow-400" />}
      {type === "Success" && (
        <IoMdCheckmarkCircleOutline className="text-accent-green" />
      )}
      {type === "Error" && <FaExclamationTriangle className="text-red-500" />}

      <h4
        className={`font-bold font-poppins
                ${type === "Success" && "text-dark-green"} 
                ${type === "Info" && "text-default-gray"}
                ${type === "Error" && "text-black"}`}
      >
        {title}
      </h4>
    </div>

    <div>
      <p
        className={`text-xs font-poppins                 
                ${type === "Success" && "text-dark-green"} 
                ${type === "Error" || (text === "Info" && "text-black")}`}
      >
        {text}
      </p>
    </div>
  </div>
);

export default CustomToast;
